import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CommentEntity } from '../../../entity/comment-entity';
import { getCommentInfo } from '../../../http/manager';
import { transaction } from "mobx";

const Comment: React.FC = () => { 
    const [ dataSource, setDataSource ] = useState<CommentEntity[]>([]);
    useEffect(()=> {
        getList();
        return;
    }, [])
    const getList = ()=> {
        getCommentInfo({}).then((res:any)=> {
            if(res.data.length > 0) {
                const list: CommentEntity[] = [];
                res.data.forEach((item:any, index:number) => {
                    item.key = index + 1;
                    list.push(item);
                })
                transaction(() => {
                    setDataSource(list);
                })
            }
        })
    }
    return (
        <CommentContainer>
            <ul>
                { dataSource.map(item=> {
                    return <li className="item" key={ item.id }>
                                <div className="title-container">{ item.username }在 <span>{ item.title }</span> 发布了 <span>留言</span></div>
                                <p className="create-time">{ item.createtime }</p>
                            </li>
                }) }
            </ul>
        </CommentContainer>
    )
}

export default observer(Comment);

const CommentContainer = styled.div`
    & {
        height: 100%;
        overflow-y: auto;
        div, p, span, ul, li {
            margin: 0;
            padding: 0;
        }
        ul {
            list-style: none;
        }
        .item {
            padding: 18px 0;
            border-bottom: 1px solid #F0F0F0;
        }
        .title-container {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            line-height: 20px;
            span {
                color: #4C77FA;
            }
        }
        .create-time {
            font-size: 14px;
            color: rgba(0,0,0,0.45);
            line-height: 20px;
        }
    }
`